import stats from "../../images/stats.svg";
import instaWhite from "../../images/insta-white.svg";
import styles from "./ImageDetail.module.css";
import web from "../../images/web.svg";

const AboutBottomSection = ({ details }) => (
  <div className="container-fluid p-3">
    <div className="row">
      <div className={`${styles.bottomSectionAboutSingle} col-12`}>
        <h4>{details ? details.about : ""}</h4>
        <p>{details ? details.about_description : ""}</p>
        <div className={styles.bottomSectionAboutSingleIconBar}>
          <span>
            <a href={details ? details.about_links.instagram : ""}>
              <img src={instaWhite} alt="Instagram Icon" />
            </a>
          </span>
          <span>
            <a href={details ? details.about_links.trans : ""}>
              <img src={stats} alt="Stats Icon" />
            </a>
          </span>
          <span>
            <a href={details ? details.about_links.web : ""}>
              <img src={web} alt="Web Icon" />
            </a>
          </span>
        </div>
      </div>
    </div>
  </div>
);

export default AboutBottomSection;
